/** @jsxImportSource theme-ui */
import { Container, Heading } from 'theme-ui';
import CreateDiscountAgreement from '@/containers/dicountAgreements/CreateDiscountAgreement';
import { useParams, useNavigate } from 'react-router-dom';

const CreateDiscountAgreementPage = () => {
    const { companyId } = useParams<{ companyId: string }>();
    const navigate = useNavigate();

    return (
        <Container>
            <Heading sx={{ textTransform: 'capitalize' }} as="h2">
                Create Discount Agreement
            </Heading>
            <CreateDiscountAgreement
                companyId={companyId}
                onSubmitSuccess={() => navigate('/voss/discount-agreements')}
            />
        </Container>
    );
};

export default CreateDiscountAgreementPage;
